import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";
import NotFound from "./NotFound";

const REF_STORAGE_KEY = "minzo_ref";

export default function RefRedirect() {
  const { refCode } = useParams<{ refCode: string }>();
  const [status, setStatus] = useState<"loading" | "found" | "not_found">("loading");

  useEffect(() => {
    if (!refCode) {
      setStatus("not_found");
      return;
    }

    supabase
      .from("tracked_clients" as any)
      .select("ref_code")
      .eq("ref_code", refCode)
      .maybeSingle()
      .then(({ data }) => {
        if (data) {
          sessionStorage.setItem(REF_STORAGE_KEY, refCode);
          setStatus("found");
        } else {
          setStatus("not_found");
        }
      });
  }, [refCode]);

  if (status === "loading") {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (status === "found") {
    return <Navigate to={`/?ref=${encodeURIComponent(refCode || "")}`} replace />;
  }

  return <NotFound />;
}
